//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.ExpressionDouble.js";
let d=[[[0,"Axis",1,"NXObject",1],[0,"AxisObject",1,"Direction",0],[0,"Body",1,"NXObject",0],[0,"BoundingBoxClearance",1,0],[0,"ClearanceType",1,0],[0,"PlaneXform",1,"Plane",0],[0,"Point",1,"NXObject",1],[0,"PointObject",1,"Point",0],[0,"Radius",1,0],[0,"SafeDistance",1,0],[1,"SafeDistanceBuilder",0,"CAM.ExpressionDouble",0]],[],[]];
SPLM.CAM.NcmClearanceBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.NcmClearanceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.NcmClearanceBuilder.ClearanceTypes = Object.freeze({
    "UseCommon" : "UseCommon", "None" : "None", "Automatic" : "Automatic", "Plane" : "Plane", "Point" : "Point", "Cylinder" : "Cylinder", "Sphere" : "Sphere", "BoundingBox" : "BoundingBox", "BoundingCylinder" : "BoundingCylinder", "Body" : "Body", "MachineBased" : "MachineBased"});

export default SPLM;